module.exports = __webpack_public_path__ + "static/media/1.f9ae15d0.png";